import 'quasar/dist/quasar.css';
import './css/global.css';

import { init } from '@/boot/legacy-init';

void init().catch((e) => console.error("legacy-init failed:", e));
